export default __webpack_public_path__ + "static/media/fillmore2.2e6b6f06.jpg";